import en_US from 'ant-design-vue/es/locale/en_US';

const messages = {
  summary: {
    title: 'Your order is:',
    promoted: 'Updated {date}.',
    finished: 'Completed {date}.',
  },
  events: {
    title: 'Track your shipment',
  },
  status: {
    CREATED: {
      title: 'In Preparation',
      subtitle: 'Your order is being prepared by the seller.'
    },
    PREPARED: {
      title: 'Ready to Ship',
      subtitle: 'Your order has been prepared and is ready to be shipped.'
    },
    IN_TRANSIT: {
      title: 'In the Hands of the Courier',
      subtitle: 'Your order has been dispatched by the seller.'
    },
    ON_THE_WAY: {
      title: 'Visit on the Way!',
      subtitle: 'Your order is on the way to your address.'
    },
    FAILED: {
      title: 'Delivery Failed',
      subtitle: 'Your order could not be delivered yet.'
    },
    DELIVERED: {
      title: 'Delivered!',
      subtitle: 'Your order has been delivered to your address.'
    },
    RETURNED: {
      title: 'Returned!',
      subtitle: 'Your order has been returned to the seller.'
    },
    CANCELED: {
      title: 'Canceled',
      subtitle: 'Your order has been canceled.'
    }
  }
}

export default {
  locale: 'en-US',
  antd: en_US,
  messages,
}
